import type { CustomerMappableField } from "@portal/app/_server/services/formFunnel/payloadTypes";
import { USER_FIELD_MUTATION_MAP } from "@portal/app/_server/services/formFunnel/payloadTypes";

/** Apply value transformation based on CMS customerFieldMapping.valueTransform */
export function transformValue(raw: string, transform: 'boolean' | 'string' | 'none'): unknown {
  if (transform === "boolean") {
    return raw === "true";
  }
  return raw;
}

/** Build GraphQL mutation variables for updateViewerCustomerDetails from a customerField + value */
export function buildMutationVariables(
  customerField: CustomerMappableField,
  value: unknown,
): Record<string, unknown> {
  // Address sub-fields → nested address object
  if (customerField.startsWith("address.")) {
    const key = customerField.split(".")[1] as string;
    return { address: { [key]: value } };
  }
  // User-level fields → map to mutation key via the shared constant
  if (customerField in USER_FIELD_MUTATION_MAP) {
    const mutationKey = USER_FIELD_MUTATION_MAP[customerField as keyof typeof USER_FIELD_MUTATION_MAP];
    return { [mutationKey]: value };
  }
  // DetailMap fields → pass through directly
  return { [customerField]: value };
}
